// @ts-nocheck

document.addEventListener("DOMContentLoaded", () => {
  const tabPanels = document.querySelectorAll('.js-schedule-form div[role="tabpanel"]');

  // アクセス時に設定済みのフォームがあればタブを切り替える
  if (getSavedForm()) {
    const activateClasses = ["active", "show"];
    const defaultTabName = "time";

    const defaultContent = [...tabPanels].find((content) => content.id === defaultTabName);
    const defaultTab = document.querySelector(`a[aria-controls='${defaultTabName}']`);
    const targetTab = document.querySelector(`a[aria-controls=${getSavedForm().id}]`);

    // tabとcontentのclass追加＆削除
    activateClasses.forEach((className) => {
      defaultTab.classList.remove(className);
      defaultContent.classList.remove(className);
      targetTab.classList.add(className);
      getSavedForm().classList.add(className);
    });
  }

  // フォーム送信時に開いているタブ以外の値を空にする。
  const workFlowTemplateFormWrap = document.getElementById("js-work-flow-template-form-wrap");

  if (workFlowTemplateFormWrap) {
    workFlowTemplateFormWrap.addEventListener("submit", (e) => {
      const closeCotents = [...tabPanels].filter((content) => {
        return !content.className.split(" ").includes("active");
      });

      closeCotents.forEach((content) => {
        const inputs = content.querySelectorAll("input");
        // 閉じたパネルのフォームをリセット
        inputs.forEach((input) => {
          input.type === "checkbox" ? (input.checked = false) : (input.value = "");
        });
      });
    });
  }

  //
  /**
   * 設定済みのformを返します
   * @return {HTMLElement} element DOM要素
   */
  function getSavedForm() {
    return [...tabPanels].find((content) => {
      const inputs = content.querySelectorAll("input");

      return [...inputs].some((input) => (input.type === "checkbox" ? input.checked : !!input.value));
    });
  }
});
